export default __webpack_public_path__ + "static/media/2.f4a45178.jpg";